import React from 'react';
import styled, { css } from 'styled-components';
import { FiInfo } from 'react-icons/fi';
import { Box, Flex, Heading, Icon, Tooltip } from 'core/components';
import getErrorBoundary from 'core/util/getErrorBoundary';
import WidgetMenu from './WidgetMenu';

const ErrorBoundaryCmp = getErrorBoundary('WidgetFrame');

const StyledBox = styled(Box)`
  scrollbar-width: thin;

  ${(props) =>
    props.hideScrollbar &&
    css`
      &::-webkit-scrollbar {
        display: none;
      }

      -ms-overflow-style: none;
      scrollbar-width: none;
    `}
`;

const WidgetFrame = React.forwardRef((props, ref) => {
  const {
    canCustomize,
    children,
    configAction,
    dragHeaderCls = 'drag-header',
    menuOptions,
    menuActions,
    onRemove,
    onDuplicate,
    icon = null,
    title,
    customRightElements,
    titleOverride,
    showTitle = true,
    showTopBar = true,
    tooltip,
    loading,
    onConfigChange,
    ...rest
  } = props;
  return (
    <ErrorBoundaryCmp>
      {showTitle && showTopBar && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          pl="12px"
          pr={0}
          minHeight={38}
          width="100%"
          className={dragHeaderCls}
        >
          <Flex gap="4px" alignItems="center" width="100%" flex={1}>
            {icon}
            {titleOverride ? (
              title
            ) : (
              <Heading level={5} mb={0} width="100%" fontSize={14}>
                {title}
              </Heading>
            )}
            {tooltip && (
              <Tooltip content={<div style={{ maxWidth: 200 }}>{tooltip}</div>} className="widget-tooltip">
                <Icon icon={FiInfo} color="primary" iconSize={18} />
              </Tooltip>
            )}
          </Flex>
          {customRightElements && customRightElements}
          {(!!menuOptions || canCustomize) && (
            <WidgetMenu
              onRemove={onRemove}
              onDuplicate={onDuplicate}
              menuOptions={menuOptions}
              configAction={configAction}
              otherActions={menuActions}
              canCustomize={canCustomize}
            />
          )}
        </Flex>
      )}
      <StyledBox overflow="auto" flex={1} showTitle={showTitle} ref={ref} {...rest}>
        {(!!menuOptions || canCustomize) && !showTitle && showTopBar && (
          <WidgetMenu
            onRemove={onRemove}
            onDuplicate={onDuplicate}
            menuOptions={menuOptions}
            configAction={configAction}
            otherActions={menuActions}
            canCustomize={canCustomize}
            dragHeaderCls={dragHeaderCls}
            floating
          />
        )}
        {children}
      </StyledBox>
    </ErrorBoundaryCmp>
  );
});

export default WidgetFrame;
